import { IntegrationType } from 'app/automations/integrations-models';

export interface CreateDataSourceRequest {
  name: string;
  url: string;
  type: DataSourceType;
  propertyDefinitions: Array<PropertyDefinition>;
  authenticationType?: AuthenticationType;
  authenticationKey?: string;
  username?: string;
  password?: string;
}

export interface UpdateDataSourceRequest {
  id: string;
  name: string;
  url: string;
  type: DataSourceType;
  propertyDefinitions: Array<PropertyDefinition>;
  authenticationType?: AuthenticationType;
  authenticationKey?: string;
  username?: string;
  password?: string;
}

export interface DataSourceModel {
  id: string;
  name: string;
  url: string;
  type: DataSourceType;
  propertyDefinitions: Array<PropertyDefinition>;
  authenticationType?: AuthenticationType;
  authenticationKey?: string;
  username?: string;
  password?: string;
}

export interface ExtractPropertyDefinitionsRequest {
  url: string;
  dataSourceType: DataSourceType;
  authenticationType?: AuthenticationType;
  authenticationKey?: string;
  username?: string;
  password?: string;
}

export interface ExtractDataSourceItemRequest {
  dataSourceId: string;
  sortBy: string;
  descending: boolean;
}

export enum JsonPropertyType {
  String = 'String',
  Number = 'Number',
  Boolean = 'Boolean',
  Array = 'Array',
  Object = 'Object',
}

export interface PropertyDefinition {
  name: string;
  type: JsonPropertyType;
}

export enum DataSourceType {
  FileByUrl = 'FileByUrl',
  RestApi = 'RestApi',
  GoogleSheets = 'GoogleSheets',
  Leaderboard = 'Leaderboard',
}

export enum AuthenticationType {
  None = 'None',
  Bearer = 'Bearer',
  Basic = 'Basic',
}

export interface DataSourceItem {
  properties: Array<DataSourceItemProperty>;
}

export interface DataSourceItemProperty {
  path: string;
  propertyType: JsonPropertyType;
  value: string;
}

export interface DataSourceGroup {
  translation: string;
  integration?: IntegrationType;
  options: DataSourceOption[];
  properties?: string[];
}

export interface DataSourceOption {
  id: string;
  name: string;
  integration?: IntegrationType;
  type: DataSourceType;
}
